import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { appClassificatorToolsApi } from "../../config/apiConfig";
import type { ClassPostObjType, PredictionObject } from "./types";

export const getClasses = (
  postObj: ClassPostObjType,
): Promise<PredictionObject> => {
  return appClassificatorToolsApi
    .post("/nlp_class", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
